<template>
  <div class="contentsArea">

    <v-card>
      <v-toolbar flat style="height:120px;" class="titleBar">
        <v-row>
          <v-card-title>職員グループ一覧</v-card-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" color="primary" @click="openCreateStaffGroupDialog()">グループ追加</v-btn>
          </v-card-actions>
        </v-row>
      </v-toolbar>
      
      <v-data-table
        :loading="loading"
        :loading-text="loadingText"
        :no-data-text="noDataText"
        :no-results-text="noResultText"
        :headers="headers"
        :items="allStaffGroupList"
        sort-by="school_grade"
        class="elevation-1"
        :footer-props="{ 'items-per-page-options': [5, 10, 15, -1], 'items-per-page-text': '行/ページ:' }"
      >

        <template v-slot:[`item.staff_in_group`]="{ item }">
          <v-btn @click="openStaffListDialog(item)" color="primary" outlined v-if="item.is_delete == 1 ? false : true">
            {{ createStaffNameListByStaffGroupId(item.staff_group_id) ? createStaffNameListByStaffGroupId(item.staff_group_id).length : 0 }}名所属
          </v-btn>
        </template>
        <template v-slot:[`item.editBtn`]="{ item }">
          <div v-if="item.is_delete == 0">
            <v-col align="center" class="px-0">
              <v-btn color="green white--text" class="mr-2" @click="openEditItem(item)">編集</v-btn>
            </v-col>
          </div>
        </template>
        <template v-slot:[`item.deleteBtn`]="{ item }">
          <div v-if="item.is_delete == 0">
            <v-col align="center" class="px-0">
              <v-btn color="red white--text" class="mr-2" @click="openInvalidDialog(item)">無効</v-btn>
            </v-col>
          </div>
          <div v-else style="align-content: center;">
            <v-col align="center" class="px-0">
              <v-chip color="grey" text-color="white">
                無効
              </v-chip>
            </v-col>
          </div>
        </template>
        <!-- <template v-slot:[`item`]="{ item }">
          <tr :style="{ backgroundColor: (item.is_delete == 1) ? '#CCC' : 'transparent' }">
            <td>{{ item.staff_group_id }}</td>
            <td>{{ item.staff_group_name }}</td>
            <td>{{ item.staff_group_detail }}</td>
            <td>
              <v-btn @click="openStaffListDialog(item)" color="primary" outlined v-if="item.is_delete == 1 ? false : true">
                {{ createStaffNameListByStaffGroupId(item.staff_group_id) ? createStaffNameListByStaffGroupId(item.staff_group_id).length : 0 }}名所属
              </v-btn>
            </td>
            <td>{{ item.created_at }}</td>
            <td class="pa-0">
              <div v-if="item.is_delete == 0">
                <v-col class="pr-0 pl-0" align="center">
                  <v-btn color="green white--text" class="mr-2" @click="openEditItem(item)">編集</v-btn>
                </v-col>
              </div>
            </td>
            <td class="pa-0">
              <div v-if="item.is_delete == 0">
                <v-col class="pl-0 pr-0" align="center">
                  <v-btn color="red white--text" class="mr-2" @click="openInvalidDialog(item)">無効</v-btn>
                </v-col>
              </div>
              <div v-else style="align-content: center;">
                <v-col align="center">
                  <v-chip color="grey" text-color="white">
                    無効
                  </v-chip>
                </v-col>
              </div>
            </td>
          </tr>
        </template> -->
        <template v-slot:[`footer.page-text`]="props">
          <div>全 {{ props.itemsLength }} 件中 {{ props.pageStart }} 件 〜 {{ props.pageStop }} 件を表示</div>
        </template>
        <template v-slot:no-data>
          データがありません
        </template>
      </v-data-table>

    </v-card>
    
    <!-- 職員をグループに追加するダイアログ -->
    <v-dialog v-if="addStaffGroupDialog" v-model="addStaffGroupDialog" width="600">
      <v-card>
        <v-card-title>職員追加</v-card-title>
        <v-card-text>
          グループ {{ staffListCurrentGroup.staff_group_name }} に追加する職員を選択してください
          <v-autocomplete chips v-model="addStaffIdList" multiple :item-text="item => item.last_name + item.first_name" 
            :item-value="item => item.staff_id" :items="addStaffGroupStaffItem(staffListCurrentGroup.staff_group_id)">
            <template v-slot:no-data>
              データがありません
            </template>
          </v-autocomplete>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addStaffGroupDialog = false">キャンセル</v-btn>
          <v-btn color="primary" :disabled="addStaffIdList.length < 1" @click="addConfirmDialog = true">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- グループに所属する職員リスト表示ダイアログ -->
    <v-dialog v-if="staffListDialog" v-model="staffListDialog" persistent max-width="600px"> 
      <v-card>
        <v-card-title>
          {{ staffListCurrentGroup.staff_group_name }}  所属職員一覧
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" color="primary" outlined
              @click="openAddStaffGroupDialog()">
              職員追加
            </v-btn>
            <v-btn :loading="loading" color="green" dark @click="staffListDialog = false">閉じる</v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div>
              <v-card-text>
                <div v-if="staffList.length == 0">
                  現在所属している職員はいません。
                </div>
                <div v-else>
                  <div v-for="(staff, index) in staffList" :key="index">
                    <v-row>
                      <div style="display: grid; place-items: center;">
                        {{ index + 1 }}
                      </div>
                      <v-col style="font-size:large; text-align: center; display: grid; place-items: center;">
                        <v-text-field readonly
                        :value="(staff.last_name + ' ' + staff.first_name)"></v-text-field>
                      </v-col>
                      <v-col style="font-size:large; text-align: center; display: grid; place-items: center;">
                        <v-btn outlined color="red" @click="deleteConfirmDialog = true, staffListCurrentGroup.staff_id = staff.staff_id">削除</v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-text>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ローディングダイアログ -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          読み込んでいます
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 無効化ダイアログ -->
    <v-dialog v-if="invalidItemDialog" v-model="invalidItemDialog" width="600">
      <v-card>
        <v-card-title>グループ無効化</v-card-title>
        <v-card-text>
          グループ「 {{ invalidItem.staff_group_name }} 」を無効化します。<br>
          よろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="invalidItemDialog = false">キャンセル</v-btn>
          <v-btn color="primary" @click="invalidStaffGroupItem()">無効化</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 削除ダイアログ -->
    <v-dialog v-if="deleteStaffGroupDialog" v-model="deleteStaffGroupDialog" width="600">
      <v-card>
        <v-card-title>グループ削除</v-card-title>
        <v-card-text>
          グループ「{{ getGroupNameByGroupId(deleteStaffGroupId) }}」を削除します。<br>
          よろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="deleteStaffGroupDialog = false">キャンセル</v-btn>
          <v-btn color="primary" @click="deleteStaffGroupByGroupId()">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 新規グループ追加ダイアログ -->
    <v-dialog v-if="createStaffGroupDialog" v-model="createStaffGroupDialog" width="600">
      <v-card>
        <v-card-title>グループ追加</v-card-title>
        <v-card-text>
          <v-form @submit.prevent v-model="isNotValid">
          <v-text-field v-model="createStaffGroupName.group_name" label="グループ名" counter="10" :rules="getGroupNameValidationRules">
          </v-text-field>
        </v-form>
        <v-textarea
            class="pt-6"
            outlined
            label="グループ説明"
            v-model="createStaffGroupName.staff_group_detail"
            counter="30"
            maxlength="30"
          ></v-textarea>
          {{ errMsg }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="createStaffGroupDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" :disabled="!isNotValid" @click="saveCreateGroupDialog = true">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 既存グループ編集ダイアログ -->
    <v-dialog v-if="editStaffGroupDialog" v-model="editStaffGroupDialog" width="600">
      <v-card>
        <v-card-title>グループ編集</v-card-title>
        <v-card-text>
          <v-form @submit.prevent v-model="isNotValid">
          <v-text-field v-model="editItem.staff_group_name" label="グループ名" counter="10" maxlength="10" :rules="[required('グループ名'), max_length_10]">
          </v-text-field>
          <v-textarea
            class="pt-6"
            outlined
            label="グループ説明"
            v-model="editItem.staff_group_detail"
            counter="30"
            maxlength="30"
          ></v-textarea>
        </v-form>
        {{ errMsg }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="editStaffGroupDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" :disabled="!isNotValid" @click="editConfirmDialog = true">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 追加確認ダイアログ -->
    <v-dialog v-if="addConfirmDialog" v-model="addConfirmDialog" width="600">
      <v-card>
        <v-card-text class="pt-5">職員をグループに追加します。よろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="addConfirmDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" @click="addStaff()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 削除確認ダイアログ -->
    <v-dialog v-if="deleteConfirmDialog" v-model="deleteConfirmDialog" width="600">
      <v-card>
        <v-card-text class="pt-5">職員をグループから削除します。よろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="deleteConfirmDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" @click="deleteRelationGroup(staffListCurrentGroup.staff_group_id, staffListCurrentGroup.staff_id)">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 編集確認ダイアログ -->
    <v-dialog v-if="editConfirmDialog" v-model="editConfirmDialog" width="600">
      <v-card>
        <v-card-text class="pt-5">グループの編集を完了します。よろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="editConfirmDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" @click="update()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- グループ追加確認ダイアログ -->
    <v-dialog v-if="saveCreateGroupDialog" v-model="saveCreateGroupDialog" width="600">
      <v-card>
        <v-card-text class="pt-5">グループを作成します。よろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" outlined @click="saveCreateGroupDialog = false">キャンセル</v-btn>
          <v-btn :loading="loading" color="primary" @click="createStaffGroupNew()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import moment from 'moment';
import { mapState, mapMutations, mapActions } from "vuex";
import {
  GET_STAFF_GROUP_ALL,
  GET_STAFF_ALL,
  CREATE_STAFF_GROUP,
  UPDATE_STAFF_GROUP,
  DELETE_STAFF_GROUP,
  INVALID_STAFF_GROUP,
  GET_STAFF_LIST_BY_STAFF_GROUP_ID,
  ADD_STAFF_LIST_STAFF_GROUP,
  DELETE_RELATION_STAFF_GROUP,
} from "@/store/action-types";
import { } from "@/store/mutation-types";
import {
  AUTHORITIES,
  NO_DATA_TEXT,
  REQUIRED_ERROR_MSG,
  MAX_LENGTH_10_ERROR_MSG,
  LOADING_TEXT,
  NO_RESULT_TEXT,
} from "@/constants";
export default {
  name: "StaffGroupSettings",
  data: () => ({
    addStaffIdList: [],
    isNotValid: false,
    noDataText: NO_DATA_TEXT,
    allStaffGroupList: [],
    authorities: AUTHORITIES,
    loadingText: LOADING_TEXT,
    noResultText: NO_RESULT_TEXT,
    staff: null,
    loading: false,
    deleteStaffGroupDialog: false,
    deleteStaffGroupId: null,
    createStaffGroupName: {},
    createStaffGroupDialog: false,
    editStaffGroupDialog: false,
    editConfirmDialog: false,
    editItem : null,
    invalidItemDialog: false,
    invalidItem: null,
    staffListCurrentGroup: null,
    staffListDialog: false,
    addStaffGroupDialog: false,
    addConfirmDialog: false,
    deleteConfirmDialog: false,
    saveCreateGroupDialog: false,
    staffList: [],
    max_length_10: value => value.length <= 10 || MAX_LENGTH_10_ERROR_MSG,
    errMsg: null,
  }),
  computed: {
    ...mapState({
      staffAll: state => state.staffAll,
      fiscalYear: state => state.fiscalYear,
    }),
    headers() {
      return [
        { text: "グループID", value: "staff_group_id" ,width: '20%'},
        { text: "グループ名", value: "staff_group_name" ,width: '20%'},
        { text: "グループ説明", value: "staff_group_detail", width: '20%' },
        { text: "所属人数", value: "staff_in_group",sortable: false ,width: '20%'},
        { text: "登録日時", value: "created_at" ,width: '20%'},
        { text: "", value: "editBtn", sortable: false ,width:'100px'},
        { text: "", value: "deleteBtn", sortable: false ,width:'100px'},
      ]
    },
    getGroupNameValidationRules() {
      if (this.createStaffGroupName && this.createStaffGroupName.group_name) {
        return [this.max_length_10];
      } else {
        return [this.required('グループ名')];
      }
    },
  },
  watch: {
    addStaffGroupDialog() {
      this.addStaffIdList = [];
    },
    allStaffGroupList() {
      for (let i = 0; i < this.allStaffGroupList.length; i++) {
        const isoDate = new Date(this.allStaffGroupList[i].created_at).toISOString();
        this.allStaffGroupList[i].created_at = moment(isoDate).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    async fiscalYear() {
      const res = await this.getStaffGroupAll();
      if (res.body == '200') {
        this.allStaffGroupList = res.result.filter(s => !s.is_delete);
      }
    },
    createStaffGroupDialog() {
      this.errMsg = null;
    },
    editStaffGroupDialog() {
      this.errMsg = null;
    },
  },
  async created() {
    this.loading = true;
    const res = await this.getStaffGroupAll();
    if (res.body == '200') {
      this.allStaffGroupList = res.result.filter(s => !s.is_delete);//削除ずみの人は配列に代入しない。
    }
    await this.getStaffAll();
    this.staff = [...this.staffAll];
    this.loading = false;
  },
  methods: {
    ...mapActions({
      getStaffGroupAll: GET_STAFF_GROUP_ALL,
      getStaffAll: GET_STAFF_ALL,
      createStaffGroup: CREATE_STAFF_GROUP,
      updateStaffGroup: UPDATE_STAFF_GROUP,
      deleteStaffGroup: DELETE_STAFF_GROUP,
      invalidStaffGroup: INVALID_STAFF_GROUP,
      getStaffListByStaffGroupId: GET_STAFF_LIST_BY_STAFF_GROUP_ID,
      deleteRelationStaffGroup: DELETE_RELATION_STAFF_GROUP,
      addStaffListStaffGroup: ADD_STAFF_LIST_STAFF_GROUP,
    }),
    ...mapMutations({
    }),
    addStaffGroupStaffItem(group_id) {
      return this.staff.filter(item => (!item.staff_group.includes(group_id) && item.authority != 1 && item.is_delete == false));
    },
    async openAddStaffGroupDialog() {
      this.loading = true;
      this.addStaffGroupDialog = true;
      this.loading = false;
    },
    async openStaffListDialog(item) {
      this.loading = true;
      this.staffListCurrentGroup = {...item};
      this.staffList = await this.createStaffNameListByStaffGroupId(this.staffListCurrentGroup.staff_group_id);
      this.staffListDialog = true;
      this.loading = false;
    },
    async openInvalidDialog(item) {
      console.log(item)
      this.loading = true;
      this.invalidItem = {...item};
      this.invalidItemDialog = true;
      this.loading = false;
    },
    async invalidStaffGroupItem() {
      this.loading = true;
      await this.invalidStaffGroup(this.invalidItem);
      const res = await this.getStaffGroupAll();
      if (res.body == '200') {
        this.allStaffGroupList = res.result.filter(s => !s.is_delete);
      }
      this.invalidItemDialog = false;
      this.loading = false;
    },
    async addStaff(){
      this.loading = true;
      await this.addStaffListStaffGroup({
        staff_group_id: this.staffListCurrentGroup.staff_group_id, 
        staff_id_list : this.addStaffIdList })
      const res = await this.getStaffGroupAll();
      if (res.body == '200') {
        this.allStaffGroupList = res.result.filter(s => !s.is_delete);
      }
      this.invalidItemDialog = false;

      await this.getStaffAll();
      this.staff = [...this.staffAll];
      this.addStaffGroupDialog = false;
      this.addConfirmDialog = false;
      this.openStaffListDialog(this.staffListCurrentGroup);
    },
    async deleteRelationGroup(staff_group_id ,staff_id) {
      this.loading = true;
      await this.deleteRelationStaffGroup({staff_group_id ,staff_id});

      const res = await this.getStaffGroupAll();
      if (res.body == '200') {
        this.allStaffGroupList = res.result.filter(s => !s.is_delete);
      }
      this.invalidItemDialog = false;

      await this.getStaffAll();
      this.staff = [...this.staffAll];
      this.deleteConfirmDialog = false;
      this.openStaffListDialog(this.staffListCurrentGroup);
    },
    async openEditItem(item) {
      console.log(item)
      this.loading = true;
      this.editItem = {...item};
      this.editStaffGroupDialog = true;
      this.loading = false;
    },
    openCreateStaffGroupDialog() {
      this.createStaffGroupName = {};
      this.createStaffGroupDialog = true;
    },
    getGroupNameByGroupId(deleteStaffGroupId) {
      const targetGroup = this.allStaffGroupList.find(staffGroup => staffGroup.staff_group_id == deleteStaffGroupId);
      return targetGroup.staff_group_name;
    },
    openDeleteStaffGroupDialog(staff_group_id) {
      this.deleteStaffGroupDialog = true;
      this.deleteStaffGroupId = staff_group_id;
    },
    async update() {
      this.loading = true;
      const updateGroupRes = await this.updateStaffGroup(this.editItem);
      if (updateGroupRes.body == '500' && updateGroupRes.err == 'same-name') {
        this.errMsg = '既に同じ名前の職員グループが存在します。';
      } else {
        const res = await this.getStaffGroupAll();
        if (res.body == '200') {
          this.allStaffGroupList = res.result.filter(s => !s.is_delete);
        }
        this.editStaffGroupDialog = false;
      }
      this.editConfirmDialog = false;
      this.loading = false;
    },
    async createStaffGroupNew() {
      this.loading = true;
      const createGroupRes = await this.createStaffGroup(this.createStaffGroupName);
      if (createGroupRes.body == '500' && createGroupRes.err == 'same-name') {
        this.errMsg = '既に同じ名前の職員グループが存在します。';
      } else {
        const res = await this.getStaffGroupAll();
        if (res.body == '200') {
          this.allStaffGroupList = res.result.filter(s => !s.is_delete);
        }
        this.createStaffGroupDialog = false;
      }
      this.saveCreateGroupDialog = false;
      this.loading = false;
    },
    async deleteStaffGroupByGroupId() {
      this.loading = true;
      await this.deleteStaffGroup(this.deleteStaffGroupId);
      const res = await this.getStaffGroupAll();
      if (res.body == '200') {
        this.allStaffGroupList = res.result.filter(s => !s.is_delete);
      }
      this.deleteStaffGroupDialog = false;
      this.loading = false;
    },
    createStaffNameListByStaffGroupId(staff_group_id) {
      if (this.staff != null && this.staff != undefined && this.staff != '') {
        const targetStaffList = this.staff.filter(staff => staff.staff_group.includes(staff_group_id));
        const targetStaffNameList = [];
        for (let i in targetStaffList) {
          targetStaffNameList.push(targetStaffList[i]);
        }
        return targetStaffNameList;
      } else {
        return [];
      }
    },
    required() {
      return value => !!value && !this.isSpace(value) || "グループ名" + REQUIRED_ERROR_MSG;
    },
    isSpace(v) {
      v = String(v);
      if(v == undefined || v == null) {
        return true;
      }
      for (let i = 0; i < v.length; i++) {
        const code = v.charCodeAt(i);
        if (code === 0x3000) { // Unicodeのコードポイントを使って全角スペースを判定
          continue; // 全角スペースの場合はループを継続
        }
        if (code === 0x20) { // 半角スペースの場合はループを継続
          continue;
        }
        return false; // それ以外の文字が含まれている場合はfalseを返す
      }
      return true; // 全角スペースか半角スペースしか含まれていない場合はtrueを返す
    }
  }
};
</script>